function getImageUrl(imageId) {
  if (imageId != null && imageId !== '') {
    let imageWithPath = `${imageId.substring(0,1)}/${imageId.substring(1,2)}/${imageId}`;
    return `${process.env.REACT_APP_IMAGES_BASE_URL || '/'}${imageWithPath}`
  }
  return ''
}

export {
  getImageUrl
}
